module.exports = __webpack_public_path__ + "img/pic-1.b03416ca.png";